import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = () => ({
  orders: JSON.parse(localStorage.getItem("orders")) || [],
  orderCurrentUser: localStorage.getItem("orderUser") || null,
  categories: [],
  categoryMeta: {
    page: 1,
    hasNextPage: true
  },
  locations: [],
  locationMeta: {
    page: 1,
    hasNextPage: true
  },
  invalidOrder: null
});

export default {
  state,
  actions,
  getters,
  mutations
};
